export default function BotStatus({ visible }) {
  if (!visible) return null
  return (
    <div id="bot-status" className="status-msg" aria-live="assertive">
      Computador pensando...
    </div>
  )
}
